export default __webpack_public_path__ + "static/media/fashion-house.c6bee757.png";